export class OidcToken {
    constructor() {
        this.businessContext = '';
        this.accessToken = '';
        this.idToken = '';
        this.scopes = '';
    }
    getAccessToken() {
        return this.accessToken;
    }
    getBusinessContext() {
        return this.businessContext;
    }
    getIdToken() {
        return this.idToken;
    }
    getScopes() {
        return this.scopes;
    }
    setAccessToken(accessToken) {
        this.accessToken = accessToken;
    }
    setBusinessContext(businessContext) {
        this.businessContext = businessContext;
    }
    setIdToken(idToken) {
        this.idToken = idToken;
    }
    setScopes(scopes) {
        this.scopes = scopes;
    }
}
OidcToken.constructFromPlainObject = (plain) => {
    let typed = new OidcToken();
    typed = Object.assign(typed, plain);
    return typed;
};
//# sourceMappingURL=oidcToken.js.map